<template>
  <el-container class="main_container w100 h100">
    <el-main :class="{'ismobilePhone':isMobilePhone}" id="comparMain">
      <div class="DataModule full_height" id="full_scrollbar">
        <!-- <el-row
            class="export-row"
            type="flex"
            justify="end"
        > -->
          <!-- <el-col style="margin-left:10px;">
            {{companyActiveMenu}} {{companyCode}}-{{companyName}}
          </el-col> -->
        <!-- </el-row> -->
        <el-row
            ref="singleTable"
            id="singleTable"
        >
          <el-table :data="tableHeaderSingleData" v-loading="loading" style="width: 100%">
            <template v-for="item in tableHeaderSingle">
              <el-table-column
                  :key="item.index"
                  :label="item.name"
                  :prop="item.value"
                  align="center"
                  sortable
                  :fixed="item.fixed"
                  height="auto"
                  width="120"
              >
              </el-table-column>
            </template>
          </el-table>
        </el-row>
        <el-row style="margin-top:6px;">
          <el-table
              :data="tableHeaderAllData"
              :height="allDataTableHeight"
               v-loading="loading"
               style="width: 100%"
          >
            <template v-for="item in tableHeaderAll">
              <el-table-column
                  :key="item.index"
                  :label="item.name"
                  :prop="item.value"
                  align="center"
                  sortable
                  :width="item.width"
                  :fixed="item.fixed"
              >
              </el-table-column>
            </template>
          </el-table>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { get_gain_compare, get_analysis_compare, get_market_compare, get_finance_compare, get_data_compare } from 'common/js/http/v3Api'
export default {
  props: {
    country: {
      type: Object,
      default: {}
    }
  },
  name: "comparison",
  data() {
    return {
      loading: true,
      isMobilePhone: false,
      SecuCode: "600000",
      companyCode: '600000.SH',
      companyName: 'Shanghai Pudong Development Bank',
      tableHeaderSingle: [],
      tableHeaderAll: [],
      tableHeaderSingleData: [],
      tableHeaderAllData: [],
      dynamicTableShow: true,
      allDataTableHeight: null
    };
  },
  computed: {
    ...mapState({
      companyActiveMenu(state) {
        return state.CompanyStatus.companyActiveMenu
      }
    })
  },
  watch: {
    companyActiveMenu: {
      handler(newVal, oldVal) {
        this.getData(this.country.name)
      },
      deep: true
    }
  },
  created() {
    this.isMobile()
  },
  mounted() {
    this.getData(this.country.name)
  },
  methods: {
    setAllDataHeight() {
      this.allDataTableHeight = window.innerHeight - window.document.getElementById('singleTable').offsetHeight + 20
      // console.log(window.innerHeight + ',' + window.document.getElementById('singleTable').offsetHeight + ',' + this.allDataTableHeight)
    },
    resetData() {
      this.tableHeaderSingle = []
      this.tableHeaderAll = []
      this.tableHeaderSingleData = []
      this.tableHeaderAllData = []
    },
    isMobile() {
      this.isMobilePhone = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );

      //isMobilePhone 代表设备信息 转换bool
      this.setMobileStatus(!!this.isMobilePhone)
    },
    async getData(func) {
      this.resetData()
      // console.log(func,this.SecuCode,this.$route.query.code)
      this.SecuCode = this.$route.query.code;
      if (func === 'Market performance comparison') {
        const { data } = await get_market_compare({ SecuCode: this.SecuCode,Timestamp: new Date().getTime()})
        this.do_market_compare(data)
      } else if (func === 'Market value analysis and comparison') {
        const { data } = await get_analysis_compare({ SecuCode: this.SecuCode,Timestamp: new Date().getTime()})
        this.do_analysis_compare(data)
      } else if (func === 'Profit forecast comparison') {
        const { data } = await get_gain_compare({ SecuCode: this.SecuCode,Timestamp: new Date().getTime()})
        this.do_gain_compare(data)
      } else if (func === 'Financial ratio comparison') {
        const { data } = await get_finance_compare({ SecuCode: this.SecuCode,Timestamp: new Date().getTime()})
        this.do_finance_compare(data)
      } else if (func === 'Financial data comparison') {
        const { data } = await get_data_compare({ SecuCode: this.SecuCode,Timestamp: new Date().getTime()})
        this.do_data_compare(data)
      }
      this.$nextTick(() => {
        setTimeout(() => { this.setAllDataHeight() }, 300)
      })
      // this.$forceUpdate();
      // this.$nextTick(() => {
      //   this.update = true
      // })
    },

    do_market_compare(data) {
      let headers = [
        { fixed: true, value: "b8", name: "Sequence number column", width: 110 },
        { fixed: true, value: "a0", name: "industry", width: 150  },
        { fixed: true, value: "a1", name: "code", width: 80  },
        { fixed: true, value: "a1_1", name: "Aggregate source code",  width: 90 },
        { fixed: true, value: "a2", name: "abbreviation", width: 100 },
        { fixed: false, value: "a3", name: "Latest date", width: 95  },
        { fixed: false, value: "a4", name: "Latest closing price (yuan)", width: 100  },
        { fixed: false, value: "a5", name: "Latest increase and decrease (%)",  width: 100 },
        { fixed: false, value: "a6", name: "Increase and decrease of this week (%)",  width: 100 },
        { fixed: false, value: "a7", name: "Increase and decrease of this month (%)",  width: 100 },
        { fixed: false, value: "a8", name: "Increase and decrease of this year (%)",  width: 100 },
        { fixed: false, value: "a9", name: "Increase and decrease in recent months (%)", width: 100  },
        { fixed: false, value: "b0", name: "Increase and decrease in recent three months (%)",  width: 100 },
        { fixed: false, value: "b1", name: "Increase and decrease in recent June (%)",  width: 100 },
        { fixed: false, value: "b2", name: "Increase and decrease in the past year (%)",  width: 100 },
        { fixed: false, value: "b3", name: "Average turnover in recent January (10000 yuan)",  width: 100 },
        { fixed: false, value: "b4", name: "Average turnover rate of last month (%)", width: 100  },
        { fixed: false, value: "b5", name: "52 week high price (yuan)", width: 100  },
        { fixed: false, value: "b6", name: "52 week low price (yuan)",  width: 100 },
        { fixed: false, value: "b7", name: "Identity column",  width: 100 }
      ]
      if (data != null && data.result.code === '200') {
        this.loading = false;
        this.tableHeaderSingle = headers
        this.tableHeaderAll = headers
        this.tableHeaderSingleData = data.result.data[1].rows
        this.tableHeaderAllData = data.result.data[0].rows
      }
    },
    do_analysis_compare(data) {
      let headers = [
        { fixed: true, value: "b8", name: "No", width: 50 },
        { fixed: true, value: "a0", name: "industry", width: 150 },
        { fixed: true, value: "a1", name: "code", width: 80 },
        { fixed: true, value: "a1_1", name: "Aggregate source code", width: 90 },
        { fixed: true, value: "a2", name: "abbreviation", width: 100 },
        { fixed: false, value: "a3", name: "Latest date", width: 95 },
        { fixed: false, value: "a4", name: "Latest closing price (yuan)", width: 100 },
        { fixed: false, value: "a5", name: "Latest increase and decrease (%)", width: 100 },
        { fixed: false, value: "a6", name: "Total market value (100 million yuan)", width: 100 },
        { fixed: false, value: "a7", name: "Market value of circulation (100 million yuan)", width: 100 },
        { fixed: false, value: "a8", name: "Earnings per share", width: 100 },
        { fixed: false, value: "a9", name: "Earnings per share (this year)", width: 100 },
        { fixed: false, value: "b0", name: "Earnings per share (next year)", width: 100 },
        { fixed: false, value: "b1", name: "Price earnings ratio", width: 100 },
        { fixed: false, value: "b2", name: "PE (current year)", width: 100 },
        { fixed: false, value: "b3", name: "PE (next year)", width: 100 },
        { fixed: false, value: "b4", name: "Market to net ratio Pb (MRQ)", width: 100 },
        { fixed: false, value: "b5", name: "Market share PCF (TTM)", width: 100 },
        { fixed: false, value: "b6", name: "Marketing rate PCF (TTM)", width: 100 },
        { fixed: false, value: "b7", name: "Identity column", width: 100 }
      ]
      if (data != null) {
        this.loading = false;
        this.tableHeaderSingle = headers
        this.tableHeaderAll = headers
        this.tableHeaderSingleData = data.result[1].rows
        this.tableHeaderAllData = data.result[0].rows
      }
    },
    do_gain_compare(data) {
      let headers = [
        { fixed: true, value: "c7", name: "Sequence number column", width: 110 },
        { fixed: true, value: "a0", name: "industry", width: 150 },
        //{fixed:true, value:	"a1", name	:"code"},
        { fixed: true, value: "a1_1", name: "Aggregate source code", width: 90 },
        { fixed: true, value: "a2", name: "abbreviation", width: 100 },
        { fixed: false, value: "a3", name: "Latest date", width: 95 },
        { fixed: false, value: "a4", name: "Latest closing price (yuan)", width: 100 },
        { fixed: false, value: "a5", name: "Investment rating", width: 100 },
        { fixed: false, value: "a6", name: "Number of institutions", width: 100 },
        { fixed: false, value: "a7", name: "Earnings per share (yuan last year)", width: 100 },
        { fixed: false, value: "a8", name: "Earnings per share (yuan this year)", width: 100 },
        { fixed: false, value: "a9", name: "Earnings per share (yuan next year)", width: 100 },
        { fixed: false, value: "b0", name: "Earnings per share (yuan next year)", width: 100 },
        { fixed: false, value: "b2", name: "P / E ratio (this year)", width: 100 },
        { fixed: false, value: "b3", name: "P / E ratio (next year)", width: 100 },
        { fixed: false, value: "b4", name: "P / E ratio (next year)", width: 100 },
        { fixed: false, value: "b5", name: "Net profit (100 million yuan last year)", width: 100 },
        { fixed: false, value: "b6", name: "Net profit (100 million yuan this year)", width: 100 },
        { fixed: false, value: "b7", name: "Net profit (100 million yuan next year)", width: 100 },
        { fixed: false, value: "b8", name: "Net profit (100 million yuan next year)", width: 100 },
        { fixed: false, value: "b9", name: "Main business income (100 million yuan last year)", width: 100 },
        { fixed: false, value: "c0", name: "Main business income (100 million yuan this year)", width: 100 },
        { fixed: false, value: "c1", name: "Main business income (100 million yuan next year)", width: 100 },
        { fixed: false, value: "c2", name: "Main business income (100 million yuan next year)", width: 100 },
        { fixed: false, value: "c3", name: "Number of forecast institutions (this year)", width: 100 },
        { fixed: false, value: "c4", name: "Number of forecast institutions (next year)", width: 100 },
        { fixed: false, value: "c5", name: "Number of forecast institutions (next year)", width: 100 },
        //{fixed:false, value:	"c6", name	:"Identity column"}
      ]
      if (data != null && data.result.code === '200') {
        this.loading = false;
        this.tableHeaderSingle = headers
        this.tableHeaderAll = headers
        this.tableHeaderSingleData = data.result.data[1].rows
        this.tableHeaderAllData = data.result.data[0].rows
      }
    },
    do_finance_compare(data) {
      let headers = [
        { fixed: true, value: "b6", name: "Sequence number column", width: 110 },
        { fixed: true, value: "a0", name: "industry", width: 150 },
        // {fixed:true, value	:	"a1", name:	"code"},
        { fixed: true, value: "a1_1", name: "Aggregate source code", width: 90 },
        { fixed: true, value: "a2", name: "abbreviation", width: 100 },
        { fixed: false, value: "a3", name: "EPS earnings per share", width: 100 },
        { fixed: false, value: "a4", name: "Net assets per share BP", width: 100 },
        { fixed: false, value: "a5", name: "Sales gross margin (%)", width: 100 },
        { fixed: false, value: "a6", name: "Net sales interest rate", width: 100 },
        { fixed: false, value: "a7", name: "Roe (%)", width: 100 },
        { fixed: false, value: "a8", name: "Year on year growth rat", width: 100 },
        { fixed: false, value: "a9", name: "Year on year growth rat", width: 100 },
        { fixed: false, value: "b0", name: "Turnover rate of accoun", width: 100 },
        { fixed: false, value: "b1", name: "Inventory turnover rate", width: 100 },
        { fixed: false, value: "b2", name: "Current ratio (Times)", width: 100 },
        { fixed: false, value: "b3", name: "Quick ratio (Times)", width: 100 },
        { fixed: false, value: "b4", name: "Equity ratio (%)", width: 100 },
        { fixed: false, value: "b5", name: "Identity column", width: 100 },
      ]
      if (data != null && data.result.code === '200') {
        this.loading = false;
        this.tableHeaderSingle = headers
        this.tableHeaderAll = headers
        this.tableHeaderSingleData = data.result.data[1].rows
        this.tableHeaderAllData = data.result.data[0].rows
      }
    },
    do_data_compare(data) {
      let headers = [
        { fixed: true, value: "b8", name: "Sequence number column", width: 110 },
        { fixed: true, value: "a0", name: "industry", width: 150 },
        // {fixed:	true,value:	"a1", name: "code"},
        { fixed: true, value: "a1_1", name: "Aggregate source code", width: 90 },
        { fixed: true, value: "a2", name: "abbreviation", width: 100 },
        { fixed: false, value: "a3", name: "Operating revenue (100 million yuan)", width: 100 },
        { fixed: false, value: "a4", name: "Operating profit (100 million yuan)", width: 100 },
        { fixed: false, value: "a5", name: "Net profit (100 million yuan)", width: 100 },
        { fixed: false, value: "a6", name: "Current assets (100 million yuan)", width: 100 },
        { fixed: false, value: "a7", name: "Long term equity investment (100 million yuan)", width: 100 },
        { fixed: false, value: "a8", name: "Total assets (100 million yuan)", width: 100 },
        { fixed: false, value: "a9", name: "Total current liabilities (100 million yuan)", width: 100 },
        { fixed: false, value: "b0", name: "Total non current liabilities (100 million yuan)", width: 100 },
        { fixed: false, value: "b1", name: "Total liabilities (100 million yuan)", width: 100 },
        { fixed: false, value: "b2", name: "Total owner's equity (100 million yuan)" },
        { fixed: false, value: "b3", name: "Net cash flow from operating activities (100 million yuan)", width: 100 },
        { fixed: false, value: "b4", name: "Net cash flow from investment activities (100 million yuan)", width: 100 },
        { fixed: false, value: "b5", name: "Net cash flow from financing and operating activities (100 million yuan)", width: 100 },
        { fixed: false, value: "b6", name: "Net increase in cash and cash equivalents (100 million yuan)", width: 100 },
        // {fixed:	false,value: "b7",name:	"Identity column"},
      ]
      if (data != null && data.result.code === '200') {
        this.loading = false;
        this.tableHeaderSingle = headers
        this.tableHeaderAll = headers
        this.tableHeaderSingleData = data.result.data[1].rows
        this.tableHeaderAllData = data.result.data[0].rows
      }
    },
    setColumnWidth(str) {
      let flexWidth = 0
      for (const char of str) {
        if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
          // 如果是英文字符，为字符分配8个单位宽度
          flexWidth += 8
        } else if (char >= '\u4e00' && char <= '\u9fa5') {
          // 如果是中文字符，为字符分配20个单位宽度
          flexWidth += 20
        } else {
          // 其他种类字符，为字符分配5个单位宽度
          flexWidth += 5
        }
      }
      if (flexWidth < 50) {
        // 设置最小宽度
        flexWidth = 200
      }
      if (flexWidth > 250) {
        // 设置最大宽度
        flexWidth = 250
      }
      return flexWidth + 10 + 'px'
    },
    ...mapMutations(["setMobileStatus", "changeIndexShow"])
  },
};
</script>
<style>
#full_scrollbar ::-webkit-scrollbar,
#full_scrollbar ::-webkit-scrollbar {
  display: block;
}
</style>
<style scoped>
.ismobilePhone {
  padding: 0 !important;
  background: #fff !important;
}
.bgw {
  background: #fff;
}
#comparMain::-webkit-scrollbar {
  display: none;
}
.w100 {
  width: 100%;
}
.h100 {
  height: 100%;
}
.el-main {
  padding: 0;
  height: 100%;
  overflow-y: scroll !important;
}
.icon {
  width: 14px;
  height: 15px;
  display: inline-block;
  position: relative;
  top: 35%;
  left: -5px;
  background-repeat: no-repeat;
  background-image: url("../../../../assets/images/white_theme/export.png");
}
.export-row {
  height: 40px;
  line-height: 40px;
  background: #fff;
  font-size: 16px;
  flex-wrap: wrap;
  flex-direction: row;
  padding-right: 10px;
}
table {
  height: calc(100% - 30px);
  width: 100%;
  padding: 10px 0;
}
tr:nth-of-type(odd) {
  background-color: #f2f2f2;
}
tr:nth-of-type(even) {
  background-color: #ffffff;
}
td {
  text-indent: 10px;
  word-wrap: break-word !important;
  overflow: visible !important;
  white-space: normal !important;
  text-overflow: ellipsis;
  border: 0;
  border-right: 1px solid #cacaca;
  height: 32px;
}
.w20 {
  width: 20%;
}
.w80 {
  width: 80%;
}
.cell:empty::before {
  content: "--";
  color: gray;
}
.dialog-title {
  font-size: 18px;
  font-weight: bold;
}
::v-deep .el-dialog__body {
  padding-top: 10px;
}
::v-deep .el-dialog__body p {
  text-indent: 2em;
}
.el-pagination {
  text-align: right;
}
::v-deep th {
  padding: 0;
}
::v-deep td {
  padding: 0;
}
</style>
